import { BreadCrumb } from "primereact/breadcrumb";

import { useHistory } from "react-router-dom";
import useCategories from "../../../../hooks/useCategories";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { locale } from "../../../../utilities/locale/locale";
import { useEffect, useState } from "react";
import { use } from "react";

const BreadCrumbProduct = ({ categoryId, product }) => {
  const { getCategoryById } = useCategories();
  const { toast } = useToastContext();
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const getCategory = async () => {
      try {
        const category = await getCategoryById(categoryId);
        setSelectedCategory(category);
      } catch (e) {
        toast({
          severity: "error",
          summary: "Error",
          detail: e.message,
          life: 3000,
        });
      }
    };

    if (categoryId) {
      getCategory();
    }
  }, [categoryId]);

  const history = useHistory();
  const labelCategory = {
    pt: selectedCategory?.descriptionPortuguese,
    en: selectedCategory?.descriptionEnglish,
    it: selectedCategory?.descriptionItalian,
    es: selectedCategory?.descriptionSpanish,
  };

  const home = {
    icon: "pi pi-home",
    command: () => {
      history.push("/shop");
    },
  };

  const itemTemplate = (item, props) => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        onClick={props.onClick}
        style={{ color: "#7A869A" }}
        className="cursor-pointer hover:underline text-sm font-medium"
      >
        <span> {item.label}</span>
      </a>
    );
  };

  const items = [
    {
      label: labelCategory[locale],
      template: itemTemplate,
      command: () => {
        history.push(
          `/shop?search=ALL&currency=ALL&type=ALL&seller=ALL&area=ALL&category=${selectedCategory.id}&page=0&size=12`
        );
      },
    },
  ];

  return (
    <BreadCrumb
      className="border-none text-sm mb-2 px-0"
      style={{ backgroundColor: "inherit", color: "#7A869A" }}
      model={items}
      home={home}
    ></BreadCrumb>
  );
};

export default BreadCrumbProduct;
